//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import ListagemPage from '../../components/templates/ListagemPage';
import { tableHelper } from '../../helpers/tableHelper';
import withAbility from '../../hoc/withAbility';
import { pedidoEmMapaService } from '../../services/pedidoEmMapa.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import PedidoEmMapaCrudListFilter from './PedidoEmMapaCrudListFilter';
import { objectsConstants } from '../../constants/objects.constants';

const endPoint = '/pedidoEmMapa/novo/';
const endPointView = '/pedidoEmMapa/';
class PedidoEmMapaCrudList extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);

    const isSudo = props.user && props.user.perfis.includes('SUDO');
    const isAdmin = props.user && props.user.perfis.includes('ADMIN');
    const isAprovador = props.user && props.user.perfis.includes('APROVADOR');

    this.columns = [
      {
        path: 'id',
        title: 'Identificador',
        isKey: true,
        dataSort: false,
        className: 'txtBold',
        hidden: true,
      },
      {
        path: 'status',
        title: 'STATUS',
        dataSort: false,
        isStatusPedido: true,
        width: '150px',
      },
      {
        path: 'numeroPedido',
        title: 'Número do pedido',
        dataSort: false,
        className: 'txtBold',
      },
      {
        path: 'createdAt',
        title: 'Data Criação',
        isDateTime: true,
        dataSort: false,
        width: '200px',
        className: 'txtBold',
      },
      // {
      //   path: 'urgente',
      //   title: 'É urgente',
      //   isKey: false,
      //   dataSort: false,
      //   yesNo: true,
      //   className: 'txtBold',
      // },

      ...(isSudo
        ? [
            {
              path: 'clienteNomeFantasia',
              title: 'Cliente',
              isKey: false,
              dataSort: false,
            },
          ]
        : []),
      {
        path: 'pontoAtendimentoNome',
        title: 'Ponto de Atendimento',
        isKey: false,
        dataSort: false,
        className: 'txtBold',
      },
      {
        path: 'tipoPedido',
        title: 'Tipo do pedido',
        isTipoPedido: true,
        isKey: false,
        dataSort: false,
      },
      {
        path: 'grupoPedido',
        title: 'Grupo',
        isKey: false,
        dataSort: false,
        dataFormat: this.renderGrupoPedido,
      },
      {
        path: 'subGrupoPedido',
        title: 'Subgrupo',
        isKey: false,
        dataSort: false,
        dataFormat: this.renderSubGrupoPedido,
      },
      { path: 'criadoPorNome', title: 'Criado por', dataSort: false },
      { path: 'aprovadoPorNome', title: 'Aprovado por', dataSort: false },
      ...(isSudo || isAdmin || isAprovador
        ? [
            {
              path: 'urgente',
              title: 'É urgente',
              isKey: false,
              dataSort: false,
              yesNo: true,
              className: 'txtBold',
            },
          ]
        : []),
      {
        path: 'id',
        title: 'Copiar',
        isKey: false,
        dataSort: false,
        width: '110px',
        dataFormat: (cell, row) => (
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={(event) => this.handleCopiarPedido(row, event)}
          >
            Copiar
          </button>
        ),
      },
    ];

    const fields = this.columns.map((col) => col.path);
    const labels = this.columns.map((col) => col.title);

    this.state = {
      labels,
      fields,
    };
  }

  getLabelFromOptions = (options, value) => {
    const item = (options || []).find((opt) => opt.value === value);
    return item ? item.label : value || '';
  };

  renderGrupoPedido = (cell) => {
    return this.getLabelFromOptions(objectsConstants.GRUPO_PEDIDO, cell);
  };

  renderSubGrupoPedido = (cell) => {
    return this.getLabelFromOptions(
      objectsConstants.SUB_GRUPO_PEDIDO_MAPA,
      cell,
    );
  };

  handleRowClick = (row: e) => {
    if (this.props.ability.can('update', 'PedidoEmMapa')) {
      this.props.history.push(endPointView + row.id);
    }
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
  };

  handleCopiarPedido = (row, event) => {
    if (event) {
      event.stopPropagation();
    }

    if (!row || !row.id) {
      return;
    }

    this.props.history.push({
      pathname: endPoint,
      state: {
        copiarDeId: row.id,
      },
    });
  };

  render() {
    const fields = this.state.fields;

    const tableColumn = _.map(this.columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={
          column.dataFormat ||
          ((cell, row, _extra, i) =>
            tableHelper.renderCustom(cell, row, column, i))
        }
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Pedido em mapa"
          subTitle=" "
          canBack={false}
        />
        <ListagemPage
          key="pedido-em-mapa"
          pageFilter="pedido-em-mapa"
          newButtonActionClick={() => {
            this.props.history.push('/pedidoEmMapa/novo');
          }}
          delete={() => {}}
          service={pedidoEmMapaService}
          showNewButton={this.props.ability.can('create', 'PedidoEmMapa')}
          labelNewButton="Novo Pedido em mapa"
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={PedidoEmMapaCrudListFilter}
          fields={fields}
          array={'pedidoEmMapas'}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(withAbility(PedidoEmMapaCrudList));
